import React from 'react';
export function MemoryCenter() {
  const stats = [{
    value: '24',
    label: 'Spaces'
  }, {
    value: '53',
    label: 'Connected Tools'
  }, {
    value: '89',
    label: 'Users'
  }, {
    value: '758',
    label: 'Chats'
  }, {
    value: '4102',
    label: 'Memories'
  }, {
    value: '722',
    label: 'Documents'
  }];
  return <div className="w-full max-w-[600px] mx-auto bg-white rounded-2xl shadow-2xl overflow-hidden border border-neutral-200" data-id="element-459">
      <div className="p-5 md:p-7" data-id="element-460">
        <div className="mb-3" data-id="element-461">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2A1B22] mb-1" data-id="element-462">
            Memory Center
          </h2>
          <p className="text-sm text-neutral-500" data-id="element-463">
            Your team's accumulated context
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 md:gap-3" data-id="element-464">
          {stats.map((stat, idx) => <div key={idx} className="bg-white border border-neutral-200 rounded-xl p-3 flex flex-col items-center justify-center shadow-sm" data-id="element-465">
              <span className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-1" data-id="element-466">
                {stat.value}
              </span>
              <span className="text-sm md:text-base text-neutral-500 font-medium" data-id="element-467">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}